import { useEffect } from "react"

export function useInitCheckoutSession() {
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    checkoutSession.savePid(searchParams.get('pid'))
  }, [])
}

export const checkoutSession = {
  savePid(pid) {
    if (pid) {
        localStorage.setItem('checkout_pid', pid)
    }
  },
  removePid() {
    localStorage.removeItem('checkout_pid')
  },
  getPid() {
    return localStorage.getItem('checkout_pid')
  },
  saveCurrency(currency) {
    if (currency) {
        localStorage.setItem('checkout_currency', currency) || 'USD'
    }
  },
  getCurrency() {
    return localStorage.getItem('checkout_currency')
  },
  saveBillingCycle(cycle) {
    if (cycle) {
        localStorage.setItem('checkout_billing_cycle', cycle)
    }
  },
  getBillingCycle() {
    return localStorage.getItem('checkout_billing_cycle') || 'monthly'
  }
}
